import React, { useContext } from "react";

import "./style.scss";
import data from "./data";
import { useStaticQuery, graphql } from "gatsby";
import { LanguageContext, text } from "../../container/language";
import moment from "moment";
import Button from "../Button";
import Link from "../../utils/Link";
import { useTranslation } from "react-i18next";
import { HomePadding } from "../HomePadding";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const newsTypeLabels = {
  NEWS: "njoftime",
  PUBLICATION: "publikime",
  ACTIVITY: "aktivitete",
  RECRUITMENT: "rekrutime",
};

const getUri = (type, slug) => {
  if (!slug) {
    return `/lajme/${newsTypeLabels[type]}`;
  }
  return `/lajme/${newsTypeLabels[type]}/${slug}`;
};

const QuickNews = () => {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  const { allStrapiNewsArticles } = useStaticQuery(graphql`
    {
      allStrapiNewsArticles(
        limit: 3
        sort: { fields: publishDate, order: DESC }
      ) {
        nodes {
          id
          created_at
          publishDate
          type
          title {
            id
            text_sq
            text_en
          }
          cover {
            size
            localFile {
              childImageSharp {
                gatsbyImageData(
                  width: 600
                  placeholder: BLURRED
                  breakpoints: [400, 750, 1080, 1366, 1920]
                )
              }
            }
          }
          displayTitle
          slug
        }
      }
    }
  `);

  const newsArticles = allStrapiNewsArticles.nodes;
  const [mainArticle, ...rest] = newsArticles;

  return (
    <>
      <div className="row text-center">
        <div>
          <h2 className="display-4 mb-3 text-center">
            <p>Njoftime dhe aktivitete</p>
          </h2>
          <p className="lead mb-10 text-center px-md-16 px-lg-21 px-xl-0">
            <p>
              Azhornohuni me njoftimet dhe aktivitetet e fundit të publikuara
              nga Shkolla e Magjistraturës.
            </p>
          </p>
        </div>
      </div>
      <section className="wrapper bg-light">
        <div className="pt-0">
          <div className="row">
            <div className="col-12">
              <div className="isotope-filter filter">
                {["NEWS", "RECRUITMENT", "ACTIVITY"].map((itemType) => (
                  <Link
                    className="btn btn-soft-aqua rounded-pill m-1"
                    to={getUri(itemType, null)}
                  >
                    {t(`pages.news.types.plural.${itemType}`)}
                  </Link>
                ))}
              </div>
            </div>
          </div>
          <div className="news-wrapper">
            {newsArticles.map((article) => (
              <div className="item">
                <article>
                  <Link to={getUri(article.type, article.slug)}>
                    <GatsbyImage
                      image={getImage(
                        article.cover.localFile.childImageSharp.gatsbyImageData
                      )}
                      alt={text(article.title, userLanguage)}
                      style={{
                        borderRadius: "10px",
                        height: "260px",
                        maxHeight: "260px",
                      }}
                    />
                  </Link>

                  <div className="post-header">
                    <div className="post-category text-line">
                      <Link
                        to={getUri(article.type)}
                        className="hover"
                        rel="category"
                      >
                        {t(`pages.news.types.${article.type}`)}
                      </Link>
                    </div>
                    <h2 className="post-title h3 mt-1 mb-3">
                      <Link
                        to={getUri(article.type, article.slug)}
                        className="link-dark"
                      >
                        {text(article.title, userLanguage)}
                      </Link>
                    </h2>
                  </div>
                  <div className="post-footer">
                    <ul className="post-meta">
                      <li className="post-date">
                        <i className="uil uil-calendar-alt"></i>
                        <span>
                          {moment(
                            article.publishDate || article.created_at
                          ).format("DD/MM/YYYY")}
                        </span>
                      </li>
                    </ul>
                  </div>
                </article>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default QuickNews;
